$('.collect-sidebar-item.lv2>a').click(function (e) {
  e.preventDefault();
  $(this).next().slideToggle();
  // $(this).next().is(':hidden') ? $(this).find('i').removeClass('active') : $(this).find('i').addClass('active')
});


$('.collect-sidebar-select').click(function () {
  $('.collect-sidebar-list').slideToggle();
  $(this).next()
})



if (isMobile()) {
  let title = $('.collect-sidebar-item.active').attr('data-title');
  let subTitle = $('.collect-sidebar-down a.on').text();
  $('.collect-sidebar-val').val(title || subTitle)
}

$('.collect-faq-box dt').click(function () {
  $(this).next().slideToggle();
  $(this).toggleClass('active')
})

if (isMobile()) {
  let width = $('.collect-compare-table').width();
  $('.collect-compare-table').width(width + 100)
}
$('.collect-toggle').click(function () {
  $(this).toggleClass('active');
  $(this).parent().prev().toggleClass('active')
})

let sideItem = document.querySelectorAll('.collect-sidebar-item');
sideItem.forEach(item => {
  if ($(item).hasClass('lv2')) {
    if ($(item).find('.collect-sidebar-down').find('a').hasClass('on')) {
      $(item).addClass('active');
    }
  }
});

let codeCopy = document.querySelectorAll('.collect-code-btn');
let clipboard = new Clipboard(codeCopy);
let toastEn =  $('.coupon-toast').data('en')
let toastFr =  $('.coupon-toast').data('fr')
let toastEs =  $('.coupon-toast').data('es')
let toastIt =  $('.coupon-toast').data('it')
let prefix = pathname.substr(0,3);
let toastText;
if(prefix == '/fr'){
	toastText = toastFr;
}else if(prefix == '/es'){
	toastText = toastEs;
}else if(prefix == '/it'){
  toastText = toastIt;
}else{
  toastText = toastEn;
}
clipboard.on('success', function (e) {
  let successCon = "<div class='tb-toast'>"+ toastText +"</div>"
  $('body').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});


$('.collect-add-btn').click(function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    quantity:1,
    id,
  }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  })
})

// 打开购物车
function toggleCart(type) {
  let cartModal = document.querySelector('.tb-shop-cart');
  let shade = document.querySelector('.tb-shade');
  if (type == 'open') {
    cartModal.classList.add('show')
    shade.classList.add('show')
  } else if (type == 'add') {
    cartModal.classList.add('show')
    setTimeout(() => {
      cartModal.classList.remove('show')
      shade.classList.remove('show')
    }, 5000)
  } else {
    cartModal.classList.remove('show')
    shade.classList.remove('show')
  }
}